import LegalPage from './LegalPage';
import { privacyBlocks } from './legalBlocks';

export default function PrivacyPage() {
  return <LegalPage blocks={privacyBlocks} />;
}
